import React, { Component } from "react";
import styled from "styled-components";

class RatesPage extends Component {
  render() {
    return (
      <RatesPageContainer>
        <h1>AppTree Software Hourly Rate for Services</h1>
        <p>
          AppTree Software has a regular hourly rate of $175 per hour and offers
          significant discounts for pre-paid services.
        </p>
        <p>
          For customers pre-paying for services, please use the table below to
          estimate your rate:
        </p>
        <table>
          <tr>
            <th>Pre-Paid Hours</th>
            <th>Discount</th>
            <th>Hourly Rate</th>
          </tr>
          <tr>
            <td>0 to 50 Hours</td>
            <td>0%</td>
            <td>$175</td>
          </tr>
          <tr>
            <td>51 to 100 Hours</td>
            <td>5%</td>
            <td>$166</td>
          </tr>
          <tr>
            <td>101 to 150 Hours</td>
            <td>10%</td>
            <td>$158</td>
          </tr>
          <tr>
            <td>151 to 200 Hours</td>
            <td>15%</td>
            <td>$149</td>
          </tr>
          <tr>
            <td>More than 200 Hours</td>
            <td>20%</td>
            <td>$140</td>
          </tr>
        </table>
        <p>
          <a href="mailto:info@apptreesoftware.com">Contact AppTree Software</a>{" "}
          for an estimate for your project. Pre-paid services do not constitute
          a not-to-exceed agreement.
        </p>
      </RatesPageContainer>
    );
  }
}

export default RatesPage;

const RatesPageContainer = styled.div`
  width: 80vw;
  height: 70vh;
  margin: auto;
  padding: 100px;

  p,
  a {
    font-size: 1.6rem;
    margin-bottom: 10px;
  }
  a {
    font-size: 1.6rem;
    background: rgba(67, 171, 96, 0.3);
    border-bottom: 4px solid rgba(67, 171, 96, 0.8);
    transition: all 0.3s ease;
  }
  a:hover {
    background: rgba(67, 171, 96, 0.8);
  }

  h1 {
    margin-bottom: 50px;
  }

  table {
    margin: 50px auto;
    border-collapse: collapse;
    width: 100%;
  }

  td,
  th {
    font-size: 1.6rem;
    border: 1px solid #dddddd;
    text-align: left;
    padding: 8px;
  }

  tr:nth-child(even) {
    background-color: #dddddd;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/rates.jsx